<template>
  <div id="eta-display">
    <p class="eta-display-title">
      預計到站時間
    </p>

    <div
      v-for="(eta, index) in etaData"
      :key="index"
      class="eta-rows"
    >
      <span>
          <span class="eta-counter">{{ index + 1 }}</span>
          <span class="eta-time">{{ eta.time }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Eta",
  props: ['etaData'],
  mounted() {
    console.log(this.etaData);
  }

}
</script>

<style scoped>
.eta-rows {
  line-height: 24px;
}

.eta-counter, .eta-time {
  display: inline-block;
}

.eta-counter {
  color: rgb(180, 180, 180);
  margin-right: 5px;
}

.eta-time {
  color: rgb(255, 80, 80);
}

.eta-display-title {
  font-size: 14px;
}

.eta-rows .eta-time {
  font-size: 19px;
}
</style>
